export default "__VITE_ASSET__BElhrW6Y__"